import { CheckCircleOutlinedIcon, RemoveCircleOutlinedIcon } from 'tuui';
import { getStatusType, STATUS_TYPE } from '../../campaigns/config/statusConsts';

export const RECENT_ACTIVITIES_PERIOD = 48;

export const PIXEL_STATE = {
    NOT_INSTALLED: 'NOT_INSTALLED',
    NO_ACTIVITY: 'NO_ACTIVITY',
};

export const TRACKING_STATUS = {
    NOT_INSTALLED: 'NOT_INSTALLED',
    NO_ACTIVITY: 'NO_ACTIVITY',
    NO_RECENT_ACTIVITY: 'NO_RECENT_ACTIVITY',
    ACTIVE: 'ACTIVE',
};

export const TRACKING_TYPE = {
    PIXEL: 'pixel',
    S2S: 's2s',
};

export const TRACKING_STATUS_CONFIG = {
    [TRACKING_STATUS.NOT_INSTALLED]: {
        id: TRACKING_STATUS.NOT_INSTALLED,
        label: 'Not Installed',
        icon: RemoveCircleOutlinedIcon,
        className: 'reject',
        descriptionCode: 'tracking.status.subtext.not.install',
        defaultMessage: 'Install Pixel to start tracking',
    },
    [TRACKING_STATUS.NO_RECENT_ACTIVITY]: {
        id: TRACKING_STATUS.NO_RECENT_ACTIVITY,
        label: 'No Recent Activity',
        icon: RemoveCircleOutlinedIcon,
        className: 'no-active',
        descriptionCode: '"tracking.status.subtext.last.active',
        defaultMessage: 'Last received {lastEvent}',
    },
    [TRACKING_STATUS.NO_ACTIVITY]: {
        id: TRACKING_STATUS.NO_ACTIVITY,
        label: 'No Activity',
        icon: RemoveCircleOutlinedIcon,
        className: 'reject',
        descriptionCode: 'tracking.status.subtext.no.active',
        defaultMessage: 'Waiting for Pixel to fire',
    },
    [TRACKING_STATUS.ACTIVE]: {
        id: TRACKING_STATUS.ACTIVE,
        label: 'Active',
        icon: CheckCircleOutlinedIcon,
        className: 'success',
        descriptionCode: 'tracking.status.subtext.last.active',
        defaultMessage: 'Last received {lastEvent}',
    },
};

export const CONVERSION_STATUS = {
    ACTIVE: 'ACTIVE',
    NO_ACTIVITY_YET: 'NO_ACTIVITY_YET',
    NO_RECENT_ACTIVITY: 'NO_RECENT_ACTIVITY',
    DISABLED: 'DISABLED',
    ARCHIVED: 'ARCHIVED',
    ALL_BUT_ARCHIVED: 'ALL_BUT_ARCHIVED',
};

export const ENGAGEMENT_TYPE = {
    GENERAL_INTEREST: 'GENERAL_INTEREST',
    DEEP_INTEREST: 'DEEP_INTEREST',
    CUSTOM: 'CUSTOM',
};

export const ENGAGEMENT_PREDICATE = {
    AND: 'AND',
    OR: 'OR',
};

export const ENGAGEMENT_PROPERTIES_TYPE = {
    TIME_ON_SITE: 'TIME_ON_SITE',
    SESSION_DEPTH: 'SESSION_DEPTH',
    SCROLL_DEPTH: 'SCROLL_DEPTH',
};

export const CONVERSION_STATUS_KEYS = Object.keys(CONVERSION_STATUS);

const nonInfoConversionStatusConfig = {
    [CONVERSION_STATUS.ACTIVE]: { statusType: STATUS_TYPE.SUCCESS },
    [CONVERSION_STATUS.NO_ACTIVITY_YET]: { statusType: STATUS_TYPE.DANGER },
};

const statusTooltipConfig = {
    [CONVERSION_STATUS.NO_ACTIVITY_YET]: {
        id: 'tracking.conversion.event.status.tooltip.no.activity.yet',
        defaultMessage: `We haven't received any events yet.{br}{br}*Status refreshes approximately every hour.`,
    },
    [CONVERSION_STATUS.ACTIVE]: {
        id: 'tracking.conversion.event.status.tooltip.active',
        defaultMessage: `We have received events from your website in the last 7 days.{br}{br}*Status refreshes approximately every hour.`,
    },
    [CONVERSION_STATUS.NO_RECENT_ACTIVITY]: {
        id: 'tracking.conversion.event.status.tooltip.no.recent.activity',
        defaultMessage: `The conversion was active in the past, but we didn't receive any events in the past 7 days.{br}{br}*Status refreshes approximately every hour.`,
    },
};

export const MILLISECONDS_IN_SECOND = 1000;
export const predicateTextMap = {
    [ENGAGEMENT_PROPERTIES_TYPE.TIME_ON_SITE]: value => ({
        id: 'tracking.conversion.engagement.summary.time.on.site',
        defaultMessage: `Time on site is ${value} seconds or more`,
        value: { value: Math.floor(value / MILLISECONDS_IN_SECOND) },
    }),
    [ENGAGEMENT_PROPERTIES_TYPE.SESSION_DEPTH]: value => ({
        id: 'tracking.conversion.engagement.summary.session.depth',
        defaultMessage: `Session depth is ${value} pages or more`,
        value: { value },
    }),
    [ENGAGEMENT_PROPERTIES_TYPE.SCROLL_DEPTH]: value => ({
        id: 'tracking.conversion.engagement.summary.scroll.depth',
        defaultMessage: `Scroll depth is ${value}% or higher`,
        value: { value },
    }),
};

export const getConversionStatusType = conversionStatus =>
    getStatusType(nonInfoConversionStatusConfig, conversionStatus);

export const getStatusTooltipText = conversionStatus => statusTooltipConfig[conversionStatus];

export const INCLUDE_IN_TOTAL_FILTER_VALUES = ['TRUE', 'FALSE'];
export const INCLUDE_IN_TOTAL_VALUE_FILTER_VALUES = ['TRUE', 'FALSE'];
export const DEFINED_CONVERSIONS_FILTER_VALUES = ['TRUE', 'FALSE'];
export const DEFINED_CONVERSIONS_VALUE_FILTER_VALUES = ['TRUE', 'FALSE'];
